<template>
  <v-dialog
    v-model="alwaysOpen"
    persistent
    :fullscreen="isMobile"
    width="80%"
    max-width="512"
    @keydown.esc="close"
  >
    <v-card class="confirm-dialog__content">
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>Delete discount list?</h1>
          <p class="text-left">
            Are you sure you want to remove this discount list? This action
            cannot be undone.
          </p>
        </v-col>
      </v-row>

      <v-row class="confirm-dialog__buttons">
        <v-col cols="6" class="text-left">
          <v-btn class="pkmn-button" outlined color="danger" @click="close">
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            class="pkmn-button pkmn-button--confirm"
            color="danger"
            @click="confirm"
          >
            Delete
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FormDeleteDiscount',
  data() {
    return {
      alwaysOpen: true,
      mobileBreakpoint: 767
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.confirm-dialog__content {
  padding: 48px 80px;
  text-align: left;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding: 40px 16px !important;
  }
}

.pkmn-button--confirm {
  color: #fff;
}

.confirm-dialog__buttons .pkmn-button {
  width: 100%;
}
</style>
